let firstTagLoad = true;

import lowerWithoutAccent from '../../common/js/lower-without-accent/lowerWithoutAccent';
import knowledgeBaseApi from '../../api/knowledge-base-api';
const GET_NEWS_RESPONSE = 'getNewsResponse';
const GET_TAGS_RESPONSE = 'getTagsResponse';
const SELECT_TAG = 'selectTag';
const PUSH_TAG = 'pushTag';
const SET_CURRENT_PAGE = 'setCurrentPage';
const SET_LOADING = 'setLoading';
const SET_TECHNICAL_ERROR = 'setTechnicalError';
const ALL_THEME_TAG = { tag: 'Összes téma', url: 'osszes' };

function transformTags(state) {
	if (state && state.tags && state.tags.length) {
		for (let i = 0; i < state.tags.length; i++) {
			let tag = state.tags[i];
			let url = lowerWithoutAccent(tag);
			let element = {
				tag: tag,
				url: url
			};
			state.tags[i] = element;
		}
	}
}

function transformArticleTags(state) {
	if (state && state.newsList && state.newsList.length) {
		for (let j = 0; j < state.newsList.length; j++) {
			let article = state.newsList[j];
			let tags = [];
			if (article && article.tags && article.tags.length) {
				for (let i = 0; i < article.tags.length; i++) {
					let tag = article.tags[i];
					let url = lowerWithoutAccent(tag);
					let element = {
						tag: tag,
						url: url
					};
					tags.push(element);
				}
			}
			state.newsList[j].tags = tags;
		}
	}
}

const newsState = {
	newsList: [],
	tags: [],
	loading: false,
	technicalError: false,
	selectedTag: {},
	allThemeTag: ALL_THEME_TAG,
	pagerStart: 0,
	allNewsCount: 0,
	currentPage: 1,
	visibleHits: 0
};

const newsActions = {
	getNews({ commit }, params) {
		return new Promise(async (resolve, reject) => {
			try {
				commit(SET_TECHNICAL_ERROR, false);
				commit(SET_LOADING, true);
				const response = await knowledgeBaseApi.getNews(params);
				commit(GET_NEWS_RESPONSE, response.data);
				commit(SET_CURRENT_PAGE, response.data.page + 1);
				resolve();
			} catch (error) {
				commit(GET_NEWS_FAILURE, error.data);
				reject();
			} finally {
				commit(SET_LOADING, false);
			}
		});
	},
	getTags({ commit }, params) {
		return new Promise(async (resolve, reject) => {
			try {
				commit(SET_TECHNICAL_ERROR, false);
				commit(SET_LOADING, true);
				const response = await knowledgeBaseApi.getTags(params);
				commit(GET_TAGS_RESPONSE, response.data);
				resolve();
			} catch (error) {
				commit(GET_TAGS_FAILURE, error.data);
				reject();
			} finally {
				commit(SET_LOADING, false);
			}
		});
	},
	selectTag({ commit }, tag) {
		commit(SELECT_TAG, tag);
	},
	pushTag({ commit }, tag) {
		commit(PUSH_TAG, tag);
	},
	setCurrentPage({ commit }, value) {
		commit(SET_CURRENT_PAGE, value);
	}
};

const newsMutations = {
	[GET_NEWS_RESPONSE](state, data) {
		state.newsList = data.content;
		state.visibleHits = data && data.content && data.content.length ? data.content.length : 0;
		transformArticleTags(state);
		state.pagerStart = 0;
		state.allNewsCount = data.totalElements;
	},
	[GET_TAGS_RESPONSE](state, data) {
		state.tags = data;
		if (firstTagLoad) {
			firstTagLoad = false;
			transformTags(state);
		}
	},
	[SELECT_TAG](state, tag) {
		state.selectedTag = tag;
	},
	[PUSH_TAG](state, tag) {
		state.tags.push(tag);
	},
	[SET_CURRENT_PAGE](state, value) {
		state.currentPage = value;
	},
	[SET_TECHNICAL_ERROR](state, error) {
		state.technicalError = error;
	},
	[SET_LOADING](state, loading) {
		state.loading = loading;
	}
};

export default {
	namespaced: true,
	state: newsState,
	mutations: newsMutations,
	actions: newsActions
};
